import React,{useEffect,FC} from 'react';
import "./CustomOverlayComp.scss";

const CustomOverlayComp : FC  = () => {

  useEffect(()=>{
    const listenerFunction=(e)=>{e.stopImmediatePropagation()};
    window.addEventListener("click",listenerFunction);

    return (()=>{window.removeEventListener("click",listenerFunction)})
  })
    /*Pure component */
  return (
    <div className="overlay-container">    
    </div>
  )
}

export default React.memo(CustomOverlayComp);